{
  "REPORT": {
    "HEADER": "Rozhovory",
    "LOADING_CHART": "Načítanie grafu...",
    "NO_ENOUGH_DATA": "Na vygenerovanie reportu sme nedostali dostatok dát, skúste to prosím neskôr.",
    "DOWNLOAD_CONVERSATION_REPORTS": "Download conversation reports",
    "DATA_FETCHING_FAILED": "Failed to fetch data, please try again later.",
    "SUMMARY_FETCHING_FAILED": "Failed to fetch summary, please try again later.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Rozhovory",
        "DESC": "( Spolu )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Prichádzajúce správy",
        "DESC": "( Spolu )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odchádzajúce správy",
        "DESC": "( Spolu )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Priemer )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Čas do riešenia",
        "DESC": "( Priemer )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Počet vyriešených problémov",
        "DESC": "( Spolu )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Počet vyriešených problémov",
        "DESC": "( Spolu )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "( Spolu )"
      },
      "REPLY_TIME": {
        "NAME": "Customer waiting time",
        "TOOLTIP_TEXT": "Waiting time is {metricValue} (based on {conversationCount} replies)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "LAST_7_DAYS": "Posledných 7 dní",
      "LAST_14_DAYS": "Posledných 14 dní",
      "LAST_30_DAYS": "Posledných 30 dní",
      "THIS_MONTH": "This month",
      "LAST_MONTH": "Last month",
      "LAST_3_MONTHS": "Posledné 3 mesiace",
      "LAST_6_MONTHS": "Posledných 6 mesiacov",
      "LAST_YEAR": "Posledný rok",
      "CUSTOM_DATE_RANGE": "Vlastný rozsah dátumov"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Použiť",
      "PLACEHOLDER": "Vybrať rozsah dátumov"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Group By",
    "DURATION_FILTER_LABEL": "Duration",
    "GROUPING_OPTIONS": {
      "DAY": "Day",
      "WEEK": "Week",
      "MONTH": "Month",
      "YEAR": "Month"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      }
    ],
    "BUSINESS_HOURS": "Otváracie hodiny",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Žiadne výsledky neboli nájdené"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Prehľad agentov",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent's name to learn more.",
    "LOADING_CHART": "Načítanie grafu...",
    "NO_ENOUGH_DATA": "Na vygenerovanie reportu sme nedostali dostatok dát, skúste to prosím neskôr.",
    "DOWNLOAD_AGENT_REPORTS": "Stiahnutie reportov o agentoch",
    "FILTER_DROPDOWN_LABEL": "Vybrat agenta",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "AGENTS": "Hľadať agentov"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Rozhovory",
        "DESC": "( Spolu )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Prichádzajúce správy",
        "DESC": "( Spolu )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odchádzajúce správy",
        "DESC": "( Spolu )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Priemer )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Čas do riešenia",
        "DESC": "( Priemer )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Počet vyriešených problémov",
        "DESC": "( Spolu )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Posledných 7 dní"
      },
      {
        "id": 1,
        "name": "Posledných 30 dní"
      },
      {
        "id": 2,
        "name": "Posledné 3 mesiace"
      },
      {
        "id": 3,
        "name": "Posledných 6 mesiacov"
      },
      {
        "id": 4,
        "name": "Posledný rok"
      },
      {
        "id": 5,
        "name": "Vlastný rozsah dátumov"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Použiť",
      "PLACEHOLDER": "Vybrať rozsah dátumov"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Labels Overview",
    "DESCRIPTION": "Track label performance with key metrics including conversations, response times, resolution times, and resolved cases. Click a label name for detailed insights.",
    "LOADING_CHART": "Načítanie grafu...",
    "NO_ENOUGH_DATA": "Na vygenerovanie reportu sme nedostali dostatok dát, skúste to prosím neskôr.",
    "DOWNLOAD_LABEL_REPORTS": "Download label reports",
    "FILTER_DROPDOWN_LABEL": "Select Label",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "LABELS": "Hľadaj označenia"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Rozhovory",
        "DESC": "( Spolu )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Prichádzajúce správy",
        "DESC": "( Spolu )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odchádzajúce správy",
        "DESC": "( Spolu )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Priemer )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Čas do riešenia",
        "DESC": "( Priemer )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Počet vyriešených problémov",
        "DESC": "( Spolu )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Posledných 7 dní"
      },
      {
        "id": 1,
        "name": "Posledných 30 dní"
      },
      {
        "id": 2,
        "name": "Posledné 3 mesiace"
      },
      {
        "id": 3,
        "name": "Posledných 6 mesiacov"
      },
      {
        "id": 4,
        "name": "Posledný rok"
      },
      {
        "id": 5,
        "name": "Vlastný rozsah dátumov"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Použiť",
      "PLACEHOLDER": "Vybrať rozsah dátumov"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Inbox Overview",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Načítanie grafu...",
    "NO_ENOUGH_DATA": "Na vygenerovanie reportu sme nedostali dostatok dát, skúste to prosím neskôr.",
    "DOWNLOAD_INBOX_REPORTS": "Download inbox reports",
    "FILTER_DROPDOWN_LABEL": "Select Inbox",
    "ALL_INBOXES": "All Inboxes",
    "SEARCH_INBOX": "Search Inbox",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "INBOXES": "Search inboxes"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Rozhovory",
        "DESC": "( Spolu )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Prichádzajúce správy",
        "DESC": "( Spolu )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odchádzajúce správy",
        "DESC": "( Spolu )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Priemer )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Čas do riešenia",
        "DESC": "( Priemer )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Počet vyriešených problémov",
        "DESC": "( Spolu )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Posledných 7 dní"
      },
      {
        "id": 1,
        "name": "Posledných 30 dní"
      },
      {
        "id": 2,
        "name": "Posledné 3 mesiace"
      },
      {
        "id": 3,
        "name": "Posledných 6 mesiacov"
      },
      {
        "id": 4,
        "name": "Posledný rok"
      },
      {
        "id": 5,
        "name": "Vlastný rozsah dátumov"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Použiť",
      "PLACEHOLDER": "Vybrať rozsah dátumov"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Team Overview",
    "DESCRIPTION": "Get a snapshot of your team's performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Načítanie grafu...",
    "NO_ENOUGH_DATA": "Na vygenerovanie reportu sme nedostali dostatok dát, skúste to prosím neskôr.",
    "DOWNLOAD_TEAM_REPORTS": "Download team reports",
    "FILTER_DROPDOWN_LABEL": "Select Team",
    "FILTERS": {
      "ADD_FILTER": "Add filter",
      "CLEAR_ALL": "Clear all",
      "NO_FILTER": "No filters available",
      "INPUT_PLACEHOLDER": {
        "TEAMS": "Hľadať tímy"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Rozhovory",
        "DESC": "( Spolu )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Prichádzajúce správy",
        "DESC": "( Spolu )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odchádzajúce správy",
        "DESC": "( Spolu )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Priemer )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Čas do riešenia",
        "DESC": "( Priemer )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Počet vyriešených problémov",
        "DESC": "( Spolu )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Posledných 7 dní"
      },
      {
        "id": 1,
        "name": "Posledných 30 dní"
      },
      {
        "id": 2,
        "name": "Posledné 3 mesiace"
      },
      {
        "id": 3,
        "name": "Posledných 6 mesiacov"
      },
      {
        "id": 4,
        "name": "Posledný rok"
      },
      {
        "id": 5,
        "name": "Vlastný rozsah dátumov"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Použiť",
      "PLACEHOLDER": "Vybrať rozsah dátumov"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT Reports",
    "NO_RECORDS": "No responses yet",
    "NO_RECORDS_DESCRIPTION": "CSAT survey responses will appear here once customers start providing feedback.",
    "DOWNLOAD": "Download CSAT Reports",
    "DOWNLOAD_FAILED": "Failed to download CSAT Reports",
    "FILTERS": {
      "ADD_FILTER": "Add filter",
      "CLEAR_ALL": "Clear all",
      "NO_FILTER": "No filters available",
      "INPUT_PLACEHOLDER": {
        "AGENTS": "Hľadať agentov",
        "INBOXES": "Search inboxes",
        "TEAMS": "Hľadať tímy",
        "RATINGS": "Search ratings"
      },
      "AGENTS": {
        "LABEL": "Agent"
      },
      "INBOXES": {
        "LABEL": "Schránka"
      },
      "TEAMS": {
        "LABEL": "Team"
      },
      "RATINGS": {
        "LABEL": "Hodnotenia"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Contact",
        "AGENT_NAME": "Agent",
        "RATING": "Hodnotenia",
        "FEEDBACK_TEXT": "Feedback comment",
        "CONVERSATION": "Conversation",
        "CUSTOMER": "Customer",
        "RESPONSE": "Response",
        "HANDLED_BY": "Handled by"
      },
      "UNKNOWN_CUSTOMER": "Unknown customer"
    },
    "NO_AGENT": "No assigned agent",
    "NO_FEEDBACK": "No feedback provided",
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Total responses",
        "TOOLTIP": "Total number of responses collected"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Satisfaction score",
        "TOOLTIP": "Total number of positive responses / Total number of responses * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Response rate",
        "TOOLTIP": "Total number of responses / Total number of CSAT survey messages sent * 100"
      },
      "RATING_DISTRIBUTION": "Rating distribution"
    },
    "REVIEW_NOTES": {
      "TITLE": "Review notes",
      "PLACEHOLDER": "Add review notes about this rating...",
      "SAVE": "Save",
      "CANCEL": "Zrušiť",
      "SAVING": "Saving...",
      "SAVED": "Notes saved successfully",
      "SAVE_ERROR": "Failed to save notes",
      "UPDATED_BY": "Updated by {name} {time}",
      "UPDATED_BY_LABEL": "Updated by",
      "PAYWALL": {
        "TITLE": "Upgrade to add review notes",
        "AVAILABLE_ON": "The review notes feature is only available in the Business and Enterprise plans.",
        "UPGRADE_PROMPT": "Add internal context to every CSAT response with review notes. Capture what really happened, spot patterns faster, and make better decisions from your feedback.",
        "UPGRADE_NOW": "Upgrade now",
        "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "TOTAL_CONVERSATIONS": {
        "LABEL": "No. of Conversations",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total Responses",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Resolution Rate",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Prehľad",
    "LIVE": "Live",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Open Conversations",
      "LOADING_MESSAGE": "Loading conversation metrics...",
      "OPEN": "Otvoriť",
      "UNATTENDED": "Unattended",
      "UNASSIGNED": "Nepriradené",
      "PENDING": "Čaká sa na"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Conversation Traffic",
      "NO_CONVERSATIONS": "No conversations",
      "CONVERSATION": "{count} conversation",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "Download report"
    },
    "RESOLUTION_HEATMAP": {
      "HEADER": "Resolutions",
      "NO_CONVERSATIONS": "No conversations",
      "CONVERSATION": "{count} conversation",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Conversations by agents",
      "LOADING_MESSAGE": "Loading agent metrics...",
      "NO_AGENTS": "There are no conversations by agents",
      "TABLE_HEADER": {
        "AGENT": "Agent",
        "OPEN": "Otvoriť",
        "UNATTENDED": "Unattended",
        "STATUS": "Status"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Team",
        "OPEN": "Otvoriť",
        "UNATTENDED": "Unattended",
        "STATUS": "Status"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Agent status",
      "ONLINE": "Online",
      "BUSY": "Zaneprázdnený",
      "OFFLINE": "Offline"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Sunday",
    "MONDAY": "Monday",
    "TUESDAY": "Tuesday",
    "WEDNESDAY": "Wednesday",
    "THURSDAY": "Thursday",
    "FRIDAY": "Friday",
    "SATURDAY": "Saturday"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "Add filter",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Žiadne výsledky neboli nájdené",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "Agent name",
        "INBOXES": "Inbox name",
        "LABELS": "Label name",
        "TEAMS": "Názov tímu"
      },
      "SLA": "SLA Policy",
      "INBOXES": "Schránka",
      "AGENTS": "Agent",
      "LABELS": "Label",
      "TEAMS": "Team"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "Konverzácia",
        "AGENT": "Agent"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "INBOX": "Schránka",
    "AGENT": "Agent",
    "TEAM": "Team",
    "LABEL": "Label",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Počet vyriešených problémov",
    "CONVERSATIONS": "No. of conversations"
  }
}
